import React from 'react'
import { PanelSecondary } from './ui_reusable/styles/Panel.styles'
import citrusAnalyticsImage from '../assets/citrus_analytics.png'
import {
  FooterContainer,
  FooterColumn,
  FooterText,
  FooterLink,
  FooterBrand,
} from './styles/Footer.styles'

/**
 * Footer component that displays company information, privacy notice, and branding
 */
const Footer: React.FC = () => {
  return (
    <PanelSecondary>
      <FooterContainer>
        <FooterColumn>
          <FooterText>
            Citrus Predict keeps your data secure and confidential. We use
            industry-standard encryption, limit access to authorized personnel,
            and comply with EU regulations. Your data never leaves our secure
            servers and is never shared.
          </FooterText>
        </FooterColumn>
        <FooterColumn>
          <FooterText>
            Citrus Predict is a product of Citrus Analytics.
          </FooterText>
          <FooterText>
            Questions or support:{' '}
            <FooterLink href="mailto:juice@gocitrus.ai">
              juice@gocitrus.ai
            </FooterLink>
          </FooterText>
        </FooterColumn>
        <FooterBrand>
          <img src={citrusAnalyticsImage} alt="Citrus Analytics" />
        </FooterBrand>
      </FooterContainer>
    </PanelSecondary>
  )
}

export default Footer
